// extracted by mini-css-extract-plugin
export default {"container":"shop_container__JIiB7"};